import Lenis from 'lenis';

export function initLenis() {

    function getIOSVersion() {
        const ua = navigator.userAgent;
        const match = ua.match(/OS (\d+)_/i);
        return match ? parseInt(match[1], 10) : null;
    }

    const iosVersion = getIOSVersion();
    const isOldIOS = iosVersion !== null && iosVersion < 16;

    const lenis = new Lenis({
        lerp: .1,
        //easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        direction: 'vertical',
        gestureDirection: 'vertical',
        smooth: true,
        wheelMultiplier: .7,
        syncTouch: !isOldIOS,    // Use syncTouch for iOS >= 16 and non-iOS
        touchMultiplier: 1.2,
        infinite: false,
        anchors: false, // Disable default anchors, we'll handle them manually
        //prevent: (node) => node.classList.contains('js-scroll')
    }); 

    // Make lenis globally available
    window.lenis = lenis;

    // Track scroll direction for header
    let lastScrollY = 0;
    let isThrottled = false;
    lenis.on('scroll', ({ scroll }) => {
        if (!isThrottled) {
            if (scroll < Math.max(lastScrollY, 300) ) {
                // Scrolling up
                document.body.classList.add('is-scrolled-up');
            } else if (scroll > lastScrollY) {
                // Scrolling down
                document.body.classList.remove('is-scrolled-up');
            }
            lastScrollY = scroll;

            isThrottled = true;
            setTimeout(() => {
                isThrottled = false;
            }, 100);
        }
    });


    // Handle anchor links on page load
    function handleInitialAnchor() {
        const hash = window.location.hash;

        if (hash && hash.length > 1) {
            // Prevent default browser jump
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }

            // Ensure we start at the top
            window.scrollTo(0, 0);

            // Wait for page to be ready
            window.addEventListener('load', function() {
                const targetId = hash.substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    // Small delay to ensure all images and content are rendered
                    setTimeout(function() {
                        targetElement.scrollToSelf();
                    }, 100);
                }
            });
        }
    }

    // Run on page load
    handleInitialAnchor();

    // Custom anchor handling with header offset
    document.addEventListener('click', function(e) {
        const link = e.target.closest('a[href^="#"]');

        if (link) {
            const href = link.getAttribute('href');

            // Ignore empty anchors or just "#"
            if (!href || href === '#') {
                return;
            }

            // Get the target element by ID
            const targetId = href.substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                e.preventDefault();

                // Scroll to target with offset
                if (window.lenis) {
                    setTimeout(function(){
                        window.lenis.scrollTo(targetElement, {
                            duration: 1.2,
                        });
                    },100);
                } else {
                    const rect = targetElement.getBoundingClientRect();
                    const targetPosition = rect.top + window.pageYOffset;
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        }
    });

    const mainElement = document.getElementById('scroll-main');
    let scrollOffset = 0;

    // Custom scrollToSelf function for elements
    Element.prototype.scrollToSelf = function () {
        /*
        const headerMain = document.querySelector('.header__main');
        if (headerMain) {
            scrollOffset = (headerMain.offsetHeight + 40) || scrollOffset;
        }
        */

        const rect = this.getBoundingClientRect();
        const targetPosition = rect.top + window.pageYOffset - scrollOffset;

        if (window.lenis) {
            window.lenis.scrollTo(this, {
                offset: -scrollOffset,
                duration: 1.2,
            });
        } else {
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
        
    };



    // Hero viewport observer: toggles a body class while the fixed header overlaps the hero
    function initHeroObserver() {

        const heroSection = document.querySelector('#hero');

        if (!heroSection) {
            document.body.classList.remove('hero-in-view');
            return;
        }

        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 80;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    document.body.classList.toggle('hero-in-view', entry.isIntersecting);
                });
            },
            {
                threshold: 0,
                rootMargin: `-${headerHeight}px 0px 0px 0px`
            }
        );

        observer.observe(heroSection);
    }

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    initHeroObserver();
    requestAnimationFrame(raf);

}

